<template>
  <div style="background-color: gray; min-height:100%">
    <button @click="downloadPdf(BaseRequest)" style="position: absolute;right: 30px;top: 15px; padding:5px; border-radius:5px; border-width:0px; background-color:#fff; color:#555;">Download PDF</button>
    <div
      class="informe-rendimento"
      style="background-color: gray;display: flex;justify-content: center;padding: 1% 0;font-weight: 300;min-height: 100%;"
    >
            <main style="width: 900px;padding: 5%;">
        <header style="margin-bottom: 3%;">
          <div style="display: flex">
          	<div style="flex: 2">
            	<img src="data:image/png;base64, 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
" alt="Logo da iouu" />
            </div>
            <div style="align-items: right">
              <label>Informe de Rendimentos Finaceiros</label>
              <br />
              <label>Imposto de Renda - Pessoa Física</label>
            </div>
          </div>
          
          <div style="margin: 10px 0px">
            <label><strong>
              Ano Calendário 2020
            </strong></label>
          </div>
        </header>
        <section style="margin-bottom: 3%;">
          <div class="title" style="margin: 50px 0px; border-bottom: #d3d3d3 solid 2px;">
            <label style="margin: 0px;">Identificação da fonte pagadora</label>
          </div>
          <div class="info" style="margin: 50px 0px;">
            <div class="item" style="display: flex;">
              <label style="flex: 2;">Nome empresarial</label>
              <label style="color: #3b46c4; align-items: right;"><strong>IOUU Tecnologia e Serviços Ltda.</strong></label>
            </div>
            <div class="item" style="display: flex;">
              <label style="flex: 2;">CNPJ</label>
              <label style="align-items: right;"><strong>26.484.548/0001-48</strong></label>
            </div>
          </div>
        </section>
        <section style="margin-bottom: 3%;">
          <div class="title" style="margin: 50px 0px; border-bottom: #d3d3d3 solid 2px;">
            <label style="margin: 0px;">Pessoa física beneficiária dos rendimentos</label>
          </div>
          <div class="info" style="margin: 50px 0px;">
            <div class="item" style="display: flex;">
              <label style="flex: 2;">Nome Completo</label>
              <label style="align-items: right;"><strong>{{DadosInvestidor.InvestidorNome}}</strong></label>
            </div>
            <div class="item" style="display: flex;">
              <label style="flex: 2;">CPF</label>
              <label style="align-items: right;"><strong>{{DadosInvestidor.InvestidorCpf}}</strong></label>
            </div>
          </div>
        </section>
        <section style="margin-bottom: 3%;">
          <div class="title" style="display: flex; margin: 50px 0px; border-bottom: #d3d3d3 solid 2px;">
            <label style="flex: 3">Bens e Direitos</label>
            <label style="align-items: right;">Valores em R$</label>
          </div>  
          <div class="rendimento" style="margin: 50px 0px;margin-bottom: 0px;">
              <div class="item" style="display: flex;">
                <label style="flex: 3;">Situação em 31.12.2019</label>
                <label style="align-items: right;"><strong>{{DadosInvestidor.ValorPrincipal2019}}</strong></label>
              </div>
              <div class="item" style="display: flex;">
                <label style="flex: 3;">Situação em 31.12.2020</label>
                <label style="align-items: right;"><strong>{{DadosInvestidor.ValorPrincipal2020}}</strong></label>
              </div>
          </div>
          
          <div class="title" style="display: flex; margin: 50px 0px; border-bottom: #d3d3d3 solid 2px;">
            <label style="flex: 3">Rendimentos sujeitos à tributação exclusiva/definitiva</label>
            <label style="align-items: right;">Valores em R$</label>
		      </div>
          <div class="rendimento" style="margin: 50px 0px;margin-bottom: 0px;">
              <div class="item" style="display: flex;">
                <label style="flex: 3;">Valor</label>
                <label style="align-items: right;"><strong>{{DadosInvestidor.ValorJuros}}</strong></label>
              </div>
          </div>
        </section>
      </main>
    </div>
  </div>
</template>

<style>
iframe.report-informe-investimento {
    visibility: hidden;
    position: absolute;
    left: 0; top: 0;
    height:0; width:0;
    border: none;
}
</style>

<script>
import ApiClientGo from "@/utils/api-client-go";
import ApiHub from "@/utils/hub-consulta-client";
import Swal from "sweetalert2";
import * as mutationTypes from '@/store/mutation-types.js'
import * as jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default {
  data() {
    return {
      dadosUsuario: {},
      DadosInvestidor: {
        InvestidorNome: "",
        InvestidorCpf: "",
        ValorJuros: 0,
        ValorPrincipal2019: 0,
        ValorPrincipal2020: 0
      },
      Rendimentos: [],
      Bens: [],
      BaseRequest: {}
    };
  },
  methods: {
    async getInforme() {
      return await ApiClientGo.getInforme()
    },
    async downloadPdf(dados) {
      const dadosEnvio = {
        NomeCompleto: dados.InvestidorNome,
        CPF: dados.InvestidorCpf,
        Bens: [],
        Rendimentos: []
      }
      const html = await ApiHub.downloadPdf(dadosEnvio)

      var iframe = document.createElement('iframe');
      iframe.className = "report-informe-investimento";
      document.body.appendChild(iframe);
      iframe.contentWindow.document.open();
      iframe.contentWindow.document.write(html.data);
      iframe.contentWindow.document.close();
    },
    async getPdf(cpf) {
      const dadosInforme = await ApiHub.getPdf(cpf)

      this.DadosInvestidor.InvestidorNome = this.dadosUsuario.investor.NomeCompleto;
      this.DadosInvestidor.InvestidorCpf = this.dadosUsuario.investor.Cpf;
      this.DadosInvestidor.ValorJuros = dadosInforme.data.ValorJuros;
      this.DadosInvestidor.ValorPrincipal2019 = dadosInforme.data.ValorPrincipal2019;
      this.DadosInvestidor.ValorPrincipal2020 = dadosInforme.data.ValorPrincipal2020;
      this.BaseRequest = this.DadosInvestidor;

      var iframe = document.createElement('iframe');
      iframe.className = "report-informe-investimento";
      document.body.appendChild(iframe);
      iframe.contentWindow.document.open();
      iframe.contentWindow.document.write(this.DadosInvestidor);
      iframe.contentWindow.document.close();
    },
    cpfFormater(cpf) {
      return (
        cpf.slice(0, 3) +
        "." +
        cpf.slice(3, 6) +
        "." +
        cpf.slice(6, 9) +
        "-" +
        cpf.slice(9, 12)
      )
    },
    cnpjFormater(cnpj) {
      cnpj = cnpj.replace(/\D/g, "")
      return (
        cnpj.slice(0, 2) +
        "." +
        cnpj.slice(2, 5) +
        "." +
        cnpj.slice(5, 8) +
        "/" +
        cnpj.slice(8, 12) +
        "-" +
        cnpj.slice(12, 14)
      )
    },
    formatValue(value) {
      if(typeof value == 'undefined'){ return 0 }
      let stringValue = (Math.floor(value * 100) / 100).toString()
      let comma = stringValue.indexOf(".")
      if(comma == -1){
        stringValue = stringValue + ".00"
      }else if(comma == stringValue.length - 2){
        stringValue = stringValue + "0"
      }
      return stringValue
    },
    formatResposta(rendimentos, valores) {
      let resposta = []
      for (let i = 0; i < rendimentos.Empresas.length; i++) {
        let respLocal = {
          Nome: "",
          Cnpj: "",
          Descricao: "",
          Valor: ""
        }

        respLocal.Nome = rendimentos.Empresas[i]
        respLocal.Cnpj = this.cnpjFormater(rendimentos.Cnpj[i])
        respLocal.Descricao = "Juros sobre empréstimo cedido"
        respLocal.Valor = this.formatValue(valores[rendimentos.IDS[i]])

        if (respLocal.Valor != "0.00") resposta.push(respLocal)
      }
      return resposta;
    },
    
    //tagueamento GA
    taggingGA() {
      this.$ga.page({
        page: '/informe-rendimento',
        title: 'Report Yield',
      })
    },
  },
  async created() {
    try {
      this.dadosUsuario = this.$store.state.currentUser;
      const cpf = this.dadosUsuario.investor.Cpf.replace('.', '')
                                                .replace('.', '')
                                                .replace('-', '');
      await this.getPdf(cpf);
    } catch (error) {
      Swal.fire(
        "Novo por aqui?",
        "Voce não possui recebimentos no ano de 2020, clique no botao para voltar a pagina de investimentos"
      ).then(result => {
        this.$router.push("/investimentos/meus-investimentos");
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/ReportYield.vue